import * as React from 'react';
import { Button } from 'antd';
import { withUserType } from '../../../components/withUserType';
import { cn } from '../../../utils/ClassNamesUtils';
import { getOscarTheme } from '../../constants/AIAgentTheme';
import { useOscarContextEnabled } from '../../hooks/useAgentChatEnabled';
import { callOscar } from '../../utils/OscarInvocation';

interface OscarPromptChipProps {
	label: string;
	/** What Oscar is asked when the chip is clicked. */
	prompt: string;
	/** Injected by `withUserType`. */
	userType?: string;
}

/**
 * A one-tap prompt under an `OscarAskInput` ("Add a reminder"): opens Oscar's drawer and sends
 * `prompt`. Renders nothing when Oscar is off for the user, the same gate as the ask input,
 * so it never shows as a button that does nothing.
 */
const OscarPromptChipBase = ({ label, prompt, userType }: OscarPromptChipProps) => {
	const enabled = useOscarContextEnabled(userType);
	if (!enabled) return null;
	const theme = getOscarTheme(userType);
	return (
		<Button
			size="small"
			shape="round"
			className={cn('[&.ant-btn]:!normal-case [&.ant-btn]:!tracking-normal', theme.chipBorder)}
			onClick={() => callOscar({ prompt })}
		>
			{label}
		</Button>
	);
};

export const OscarPromptChip = withUserType(OscarPromptChipBase);
